<template>
  <div class="login">
    <div class="login_title">用户登录</div>
    <div class="phoneNum"><input type="text" placeholder="请输入注册手机号" maxlength="11" v-model="phoneNum"></div>
    <div class="pwd"><input type="text" placeholder="请输入验证码" v-model="captcha" maxlength="5"><div @click="toSendMsg" v-if="countDown == 120">获取验证码</div><div class="count_down" v-else="">{{countDown}}秒后获取</div></div>
    <div class="agreement"><span class="check" v-if="!agree" @click="changeAgree()"></span><img class="checked" src="../../images/checked.png" alt="" @click="changeAgree()" v-if="agree">我已阅读<span class="to_agree" @click="changePage({name:'guardianship'})">《服务协议》</span><span class="to_agree" @click="changePage({name:'addicted'})">《隐私保护策略》</span></div>
    <div class="to_login" @click="toLogin">登录</div>
    <div class="under_login">还没有账号，<span class="to_reg" @click="toReg">立即注册</span></div>
  </div>
</template>

<script>
  import {hex_md5} from '../../utils/md5.js'
  import { mapMutations } from 'vuex'
  import { mapState } from 'vuex'
  export default {
    data(){
      return{
        agree:true,
        haslogin:true,
        nicname:'',
        phoneNum:"",
        appSecret : "b43f0148b81511957b28e011584ea4c73570f700784cdf7891f1c040a353baca",
        clientType:3,
        captcha:"",
        countDown:120,
        countFunction:null,
        errDesc:{
          1007:"手机号输入有误请从新输入",
          10042:"短信验证码获取频次过高，请稍后再试。",
          10043:"短信验证码获取频次过高，请稍后再试。",
          10044:"短信验证码获取频次过高，请稍后再试。"
        }
      }
    },
    mounted:function(){
      var nicname=sessionStorage.getItem('nickname');
      if(nicname&&nicname!=""){
        this.nicname=nicname;
        this.haslogin=false;
      }
    },
    methods:{
      ...mapMutations([
        'setUser','setLoginState','setAsset'
      ]),
      changeAgree(){
        this.agree = !this.agree;
      },
      loginout:function(){
        sessionStorage.removeItem('nickname');
        let url=this.$route.path;
        if(url=='/home'){
          window.location.reload();
        }
        this.$router.push({name:'home'});
      },
      sendMsg(){
        let sign =hex_md5('cstId=50110&tel='+this.phoneNum+'&templateId=1&key=230b88662d9d1dfe22625d80b1f7bc04');
        this.$axios({
          url: this.$ajaxUrls.sendMessage,
          method: 'post',
          params:{
            tel:this.phoneNum,
            cstId: 50110,
            templateId: 1,
            sign:sign
          },
          headers:{
            'Content-Type':'application/json'
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.open("发送成功,请查收");
            this.countFunction = setInterval(()=>{
              this.countDown -= 1;
              if(this.countDown === 0){
                clearInterval(this.countFunction);
                this.countDown = 120;
              }
            },1000);
          }else{
            this.open(this.errDesc[res.data.errCode])
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      open(msg='发送失败') {
        this.$alert(msg, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      },
      //nonce生成*位随机串
      getNonce(len, charSet){
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length);
          randomString += charSet.substring(randomPoz,randomPoz+1);
        }
          return randomString;
      },
      sign(method,appId,nonce,timestamp,signUrl,appSec){
        var str = method + 'X-QP-AppId:'+appId+'X-QP-Nonce:'+nonce+'X-QP-Timestamp:'+timestamp+signUrl+appSec;
        var newStr = hex_md5(str).toUpperCase();
        return newStr;
      },
      getOS(){
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          return 'ios';
        } else if (/(Android)/i.test(navigator.userAgent)) {
          return 'android';
        }
      },
      toLogin(){
        this.checkPhoneNum(this.reg);
      },
      toSendMsg(){
        this.checkPhoneNum(this.sendMsg)
      },
      reg(){
        if(this.captcha === ""){
          this.open("请输入验证码。");
          return false
        }
        if(!/^\d{5}$/.test(this.captcha)){
          this.open("验证码错误，请输入正确有效的短信验证码。");
          return false
        }
        if(!this.agree){
          this.open("请先阅读并同意《服务协议》《隐私保护策略》");
          return false
        }
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.uc + '/uc/v1/loginonly/phone?appId=200010&captcha='+this.captcha+'&mobilePhone='+this.phoneNum;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':200010,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',200010,lnonce,ltimestamp,url,this.appSecret)
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.open("登录成功");
            this.setUser(res.data.data);
            this.setLoginState(true);
            this.getAsset(res.data.data.gid);
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      toReg(){
        this.$router.push({name:'reg'});
      },
      getAsset(gid){
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.ams + gid;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':200010,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',200010,lnonce,ltimestamp,url,this.appSecret)
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            let result = {};
            res.data.data.forEach(function (e) {
              if(e.assetId ==1002){
                result =e;
              }
            });
            this.setAsset(result)
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      changePage(path){
        this.$router.push(path)
      },
      checkPhoneNum(callback){
        if(this.phoneNum == ""){
          this.open("请输入手机号");
          return false
        }
        if(!/^1[34578]\d{9}$/.test(this.phoneNum)){
          this.open("请输入正确的手机号");
          return false
        }
        let sign =hex_md5('gameId=200010&telphone='+this.phoneNum+'&key=B1081EE774CE54FB6CAC6075009729183c6e0b8a9c15224a8228b9a98ca1531d').toUpperCase();
        this.$axios({
          url: this.$ajaxUrls.check,
          method: 'get',
          params:{
            gameId: 200010,
            sign:sign,
            telphone:this.phoneNum
          },
          headers:{
            'Content-Type':'application/json'
          }
        }).then((res)=>{
          console.log(res.data);
          if(res.data.meta.code === '6043'){
            callback();
          }else{
            this.open('账号不存在，请输入正确的手机号。')
          }
        }).catch((err)=>{
          alert(err)
        })
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .login{width: 338px;height: 378px;border-radius: 8px;background:url("../../images/login_bg.png") no-repeat;padding:45px 36px 0 36px;background-size:338px 378px; }
  .login_title{color: #333333;font-size: 24px;margin-bottom: 20px}
  .phoneNum,.pwd{width: 260px;height: 42px;margin-bottom: 20px}
  .phoneNum input{height: 42px;font-size: 14px;background-color: rgb(247,247,247);width: 100%;border-radius: 5px;padding-left: 10px}
  input::-webkit-input-placeholder { color: #999;}
  input::-moz-placeholder{ color: #999;}
  input:-ms-input-placeholder{ color: #999;}
  .pwd input{height: 42px;font-size: 14px;width: 144px;background-color: rgb(247,247,247);margin-right: 10px;border-radius: 5px;padding-left: 10px}
  .pwd div{display: inline-block;background-color: #1990FF;border-radius: 5px;color: #ffffff;text-align: center;height: 42px;width: 96px;line-height: 42px;cursor: pointer;font-size: 14px}
  .agreement{font-size: 12px;margin-bottom: 20px}
  .check{display: inline-block;width: 16px;height: 16px;border-radius: 5px;border: 1px solid #ccd5db;cursor: pointer;vertical-align: text-bottom;margin-right: 5px}
  .checked{display: inline-block;width: 16px;height: 16px;border-radius: 5px;border: 1px solid #ccd5db;color: #1990FF;font-weight: bold;cursor: pointer;vertical-align: text-bottom;margin-right: 5px}
  .to_agree{cursor: pointer;color: #1990FF}
  .to_login{width:272px;height:53px;background: url("../../images/login_btn.png") no-repeat;background-size: 272px 53px;color: #ffffff;text-align: center;font-size: 14px;padding-top: 13px;cursor: pointer;margin-bottom: 5px}
  .under_login{width: 260px;text-align: right;font-size: 14px}
  .to_reg{color: #1990FF;cursor: pointer}
  .pwd .count_down{color: #999999;background-color: rgb(247,247,247)}
</style>
